import React, {useState, useEffect} from 'react';
import moment from 'moment';

import ptLocale from "date-fns/locale/pt-BR";
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import {
    Popover,
    IconButton,
    Input,
    InputLabel,
    InputAdornment,
    FormControl,
    Grid,
    Typography,
    Button,
    Divider,
    Dialog,
} from '@material-ui/core';
import {CalendarToday} from '@material-ui/icons';

import ButtonClose from "../../buttonClose/.mixins/buttonClose";

import 'date-fns';
import 'moment/locale/pt-br';

//css
import Styles from './styles';
const useStyles = Styles();

export default ({
    inputLabel,
    popupLabel,
    value,
    maxDate,
    minDate,
    openDialogCalendar,
    handlerChangeDate,
    handlerOpenDataSugestao,
    handlerConfirmarDataSugestao,
}) => {
    const classes = useStyles();
    
    const [dtCalendar, setDtCalendar] = useState(value);
    const [dtCalendarMask, setDtCalendarMask] = useState(moment(value).format("DD/MM/YYYY"));

    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [placement, setPlacement] = useState();

    const handleClick = (event) => {
        const newPlacement = 'bottom';
        setAnchorEl(event.currentTarget);
        setOpen((prev) => placement !== newPlacement || !prev);
        setPlacement(newPlacement);
    };

    const handleDtCalendarMask = (event) => {
        let valorCalendario = event.target.value;
        let novoValorCalendario = valorCalendario;
        
        if (valorCalendario.length > 10) return;

        if (valorCalendario.match(/^\d{2}$/) !== null) {
            novoValorCalendario = valorCalendario + '/';
        } else if (valorCalendario.match(/^\d{2}\/\d{2}$/) !== null) {
            novoValorCalendario = valorCalendario + '/';
        }

        if (valorCalendario.length == 10) {
            setDtCalendarMask(moment(novoValorCalendario,"DD/MM/YYYY").format("DD/MM/YYYY"));
        } else {
            setDtCalendarMask(novoValorCalendario);
        }
    };

    const handleDtCalendar = (event) => {
        setDtCalendar(event);
        setDtCalendarMask(moment(event).format("DD/MM/YYYY"));
    };

    const handleClose = () => {
        setOpen(false);
        setDtCalendar(value);
        setDtCalendarMask(moment(value).format("DD/MM/YYYY"));
        if (!inputLabel) {
            handlerOpenDataSugestao(false);
        }
    };

    const handlerConfirmar = () => {
        setOpen(false);
        if (!inputLabel) {
            handlerConfirmarDataSugestao();
        }
        handlerChangeDate(dtCalendar);
        setDtCalendar(new Date());
    };

    const Content = () => {
        return (
            <div 
            style={{
                overflowX: "hidden",
                overflowY: "hidden",
            }}>
                <Typography align={"center"} className={classes.root}>
                    {popupLabel}
                    <ButtonClose closeMethod={handleClose}/>
                </Typography>
                <Divider />
                <MuiPickersUtilsProvider 
                    utils={DateFnsUtils}
                    locale={ptLocale}
                >
                    <KeyboardDatePicker
                        id="dt_lancamento"
                        variant="static"
                        margin="normal"
                        label="Início Vigência"
                        format="dd/MM/yyyy"
                        invalidDateMessage="Data inválida"
                        cancelLabel="Cancelar"
                        disableToolbar
                        onChange={handleDtCalendar}
                        value={dtCalendar}
                        minDate={minDate}
                        maxDate={maxDate}
                        className={classes.textField}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        InputProps={{
                            className: classes.multilineColor
                        }}
                    />
                </MuiPickersUtilsProvider>
                <Divider />
                <br/>
                <div align={"center"}>
                    {moment(dtCalendar).locale('pt-br').format('dddd[,] DD [de] MMMM [de] YYYY')}
                </div>
                <Grid
                    container
                    spacing={2}
                    className={classes.footer}
                >
                    <Button 
                        variant="contained" 
                        color="primary"
                        className={classes.bt_confirmar}
                        onClick={handlerConfirmar}
                    >
                        CONFIRMAR
                    </Button>
                </Grid>
            </div>
        );
    };

    return (
        <>
            {inputLabel &&
                <>
                    <FormControl style={{width:"100%"}}>
                        <InputLabel htmlFor="standard-adornment-password">
                            {inputLabel}
                        </InputLabel>
                        <Input
                            type={'text'}
                            onChange={handleDtCalendarMask}
                            value={dtCalendarMask}
                            anchororigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformorigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        color={"primary"}
                                        aria-label="Escolha data"
                                        onClick={handleClick}
                                    >
                                        <CalendarToday/>
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                    <Popover
                        id={"popoverCalendar"}
                        open={open}
                        anchorEl={anchorEl}
                        placement={placement}
                        transition={"true"}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        onClose={handleClose}
                    >
                        <Content/>
                    </Popover>
                </>
            }
            
            <Dialog
                open={openDialogCalendar}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <Content/>
            </Dialog>
        </>
    );
};
